exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n*[data-v-2e29e73c] {\n  font-family: Moderat;\n  font-style: normal;\n  font-weight: normal;\n}\n", ""]);

// exports
